import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Register from '@/views/register'
import registerteam from '@/views/registerteam'
import Layout from '@/views/Layout'
import Index from '@/views/Index'
import Matches from '@/views/Match'
import Accounts from '@/views/Account'
import Hosts from '@/views/Host'
import Teams from '@/views/Teams'
import MyTeam from '@/views/MyTeam'
import Articles from '@/views/Article'
import PublishArticle from '@/views/PublishArticle'
import MatchDetail from '@/views/MatchDetail'
import ChangePasword from '@/views/ChangePassword'
import TeamPlayers from '@/views/teamplayerlist'
import NewsDetail from '@/views/newsDetail'
import Chart from '@/views/PlayerChart'
Vue.use(Router)

export default new Router({
    //mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/registerhost',
            name: 'Register',
            component: Register,
            meta: {
                requireAuth: false,
            },
        },
        {
            path: '/registerteam',
            name: 'RegisterTeam',
            component: registerteam,
            meta: {
                requireAuth: false,
            },
        },
        {
            path: '/findpassword',
            name: 'findpassword',
            component: resolve=>require(['../views/findpassword.vue'], resolve),
            meta: {
                requireAuth: false,
            },
        },       
        {
            path: '/resetpassword',
            name: 'resetpassword',
            component: resolve=>require(['../views/ResetPassword.vue'], resolve),
            meta: {
                requireAuth: false,
            },
        },
        {
            path: '/',
            name: '首页',
            component: Layout,
            meta: {
                requireAuth: true,
            },
            children: [
                {
                    path: '/',
                    name: '首页',
                    component: Index,
                    meta: {
                        requireAuth: true,
                    }
                }, {
                    path: '/changePassword',
                    name: '修改密码',
                    component: ChangePasword,
                    meta: {
                        requireAuth: true,
                    }
                },
                {
                    path: '/matches',
                    name: '',
                    component: Matches,
                    meta: {
                        requireAuth: true,
                    }
                },
                {
                    path: '/accounts',
                    name: '用户管理',
                    component: Accounts,
                    meta: {
                        requireAuth: true,
                    }
                },
                {
                    path: '/hosts',
                    name: '主办方',
                    component: Hosts,
                    meta: {
                        requireAuth: true,
                    }
                },
                {
                    path: '/teams',
                    name: '代表队',
                    component: Teams,
                    meta: {
                        requireAuth: true,
                    }
                }, {
                    path: '/myteam',
                    name: '我的代表队',
                    component: MyTeam,
                    meta: {
                        requireAuth: true,
                    }
                },
                {
                    path: '/teamplayers',
                    name: '代表队',
                    component: TeamPlayers,
                    meta: {
                        requireAuth: true,
                    }
                },
                {
                    path: '/articles',
                    name: '文章管理',
                    component: Articles,
                    meta: {
                        requireAuth: true,
                    }
                },
                {
                    path: '/publisharticle',
                    name: '发布文章',
                    component: PublishArticle,
                    meta: {
                        requireAuth: true,
                    }
                },
                {
                    path: '/matchdetail',
                    name: '比赛详情',
                    component: MatchDetail,
                    meta: {
                        requireAuth: true,
                    }
                },
                {
                    path: '/newsDetail',
                    name: '新闻详情',
                    component: NewsDetail,
                    meta: {
                        requireAuth: true,
                    }
                }
                ,
                {
                    path: '/playerchartset',
                    name: '图表设置',
                    component: Chart,
                    meta: {
                        requireAuth: false,
                    }
                },{
                    path: '/playerlist',
                    name: '选手列表',
                    component: resolve=>require(['../views/playerlist.vue'], resolve),
                    meta: {
                        requireAuth: false,
                    }
                } ,{
                    path: '/approve',
                    name: 'approve',
                    component: resolve=>require(['../views/approve.vue'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                },
                ,{
                    path: '/teamApprove',
                    name: 'teamApprove',
                    component: resolve=>require(['../views/teamApprove.vue'], resolve),
                    meta: {
                        requireAuth: true,
                    },
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js